export default "__VITE_ASSET__CJwo7Ga2__"